import React from 'react';

const Jqueryicon = () => {
  return (
   <svg className=" iconSize" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.87 152.04">
        <rect class="cls-20" x="2.08" y="2.11" width="155.87" height="148.04" rx="37.01" ry="37.01"/>
        <path class="cls-10" d="m121.74,2c19.95,0,36.13,16.17,36.13,36.13v75.79c0,19.95-16.17,36.13-36.13,36.13H38.13c-19.95,0-36.13-16.17-36.13-36.13V38.13C2,18.17,18.17,2,38.13,2h83.62m0-2H38.13C17.1,0,0,17.1,0,38.13v75.79c0,21.02,17.1,38.13,38.13,38.13h83.62c21.02,0,38.13-17.1,38.13-38.13V38.13c0-21.02-17.1-38.13-38.13-38.13h0Z"/>
        <path class="cls-30" d="m137.02,99.16c-38.5,74.3-152.45-1.01-96.96-62.44-24.28,62.42,60.44,103.54,96.96,62.44Z"/>
        <path class="cls-30" d="m139.63,71.89c-26.26,52.51-111.47,2.48-69.99-45.44-19.68,42.96,42.25,77.15,69.99,45.44Z"/>
        <path class="cls-30" d="m135.92,50.62c-12.63,30.19-69.11,1.46-41.83-30.5-12.91,27.5,26.23,48.3,41.83,30.5Z"/>
</svg>
  );
}

export default Jqueryicon;

